import React, { PropsWithChildren } from 'react'
import { Icon, IconType } from '..'
import cn from 'classnames'

interface Props {
  type: ButtonType
  to?: string
  icon?: IconType
  onClick?: (e?: any) => void
  className?: string
  label?: string
  nativeType?: 'button' | 'submit' | 'reset'
  id?: string
}

export type ButtonType = 'primary' | 'secondary' | 'primary-inverted'

/**
 *
 * @deprecated try using Button instead mate
 */
const Button = ({
  type = 'primary',
  onClick,
  icon,
  className = '',
  label = '',
  nativeType,
  id
}: PropsWithChildren<Props>) => {
  const types = {
    primary: 'button--primary',
    secondary: 'button--secondary',
    'primary-inverted': 'button--primary-inverted'
  }

  if (type === 'primary' || type === 'primary-inverted') {
    return (
      <button
        className={cn(types[type], className, { buttonPrimaryRipple: type === 'primary' })}
        onClick={onClick}
        type={nativeType}
        tabIndex={0}
        id={id}
      >
        {icon && <Icon type={icon} containerClass='pr-2' />}
        <span>{label}</span>
      </button>
    )
  }
  if (type === 'secondary') {
    return (
      <button
        className={cn(types[type], className, 'buttonSecondaryRipple d-flex align-items-center', {
          'button--animate-icon': icon === 'arrowRight'
        })}
        onClick={onClick}
        type={nativeType}
        tabIndex={0}
        id={id}
      >
        <span>{label}</span>
        {icon && <Icon type={icon} containerClass='pl-2' />}
      </button>
    )
  } else return null
}

export default Button
